import styled from "styled-components";
import mediaQuery, { Screen } from "../../Utilities/MediaQuery";
import { theme } from "styled-tools";

export const Form = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  align-self: center;
  margin-inline: 24px;

  ${mediaQuery[Screen.mobile]} {
    label,
    span {
      font-size: 18px;
    }
  }
`;

export const ButtonSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const ImgContact = styled.img`
  width: 100%;

  ${mediaQuery[Screen.lg]} {
    display: none;
  }
  ${mediaQuery[Screen.xl]} {
    display: none;
  }

  ${mediaQuery[Screen.xxl]} {
    display: none;
  }
`;

export const ContactButton = styled.button`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  background: ${theme("Primary_600")};

  span {
    padding-left: 10px;
    padding-right: 10px;
    font-size: 20px;
    font-family: Poppins;
    font-weight: 600;
    line-height: 100%;
    color: ${theme("Lotion")};
  }
`;
